





























































import {Vue, Component, Prop} from 'vue-property-decorator'

@Component({})
export default class InvocationNetworkSelection extends Vue {
  @Prop({required: true, type: Array}) networkOptions!: string[]
  @Prop({required: true, type: String}) selectedNetwork!: string

  handleSelectNetwork(network: string) {
    this.$emit('select-network', network)
  }
}
